import { jobs_helper } from "@/helpers/jobs_helper";
import { speciality_helper } from "@/helpers/speciality_helper";
import { JobCard, Title } from "@/ui";
import clsx from "classnames";
import { chunk } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { Carousel, Col, Container, Row, Stack } from "react-bootstrap";
import classes from "./styles.module.scss";
import CTA from "@/ui/CTA";

export const LatestJobs = ({
  className,
  bgColor,
  textColor,
  title,
  titleColor,
  button,
  visibleCount,
  specialty,
  filters,
  currency,
}) => {
  const specialtyDetails = useMemo(() => speciality_helper.find(specialty, "id"), [specialty]);
  //console.log(visibleCount)
  const [activeFilter, setActiveFilter] = useState("all");
  const [computedItems, setComputedItems] = useState([]);
  const allJobs = useMemo(() => jobs_helper.fetch(), []);

  useEffect(() => {
    let filteredJobs = allJobs;

    if (activeFilter !== "all") {
      filteredJobs = filteredJobs.filter((job) =>
        job.categories?.some(
          (category) => category.name === "Speciality" && category.values?.some((value) => value.id === activeFilter),
        ),
      );
    }

    if (currency) {
      filteredJobs = filteredJobs.filter((job) => job.currency === currency);
    }

    setComputedItems(filteredJobs);
  }, [activeFilter, allJobs, currency]);

  const hasJobs = computedItems.length > 0;

  return (
    <div className={clsx(className, bgColor, textColor, classes.jobs)}>
      <Container className="mw-xxl">
        <Stack className="flex-md-row justify-content-between mb-4">
          <Title title={title} className={clsx(titleColor, "text-secondary text-center text-md-start mb-md-0")} />

          {filters && (
            <Stack
              as="aside"
              className={clsx(classes.jobs__filter, "flex-md-row justify-content-end flex-grow-0")}
              gap={3}
            >
              <Stack className="flex-row flex-grow-0 justify-content-center" gap={2}>
                <a onClick={() => setActiveFilter("all")} className={clsx({ active: activeFilter === "all" })}>
                  All
                </a>
                {specialtyDetails?.title?.toLowerCase() !== "all" && specialtyDetails?.id && (
                  <a
                    onClick={() => setActiveFilter(specialtyDetails.id)}
                    className={clsx({ active: activeFilter === specialtyDetails.id })}
                  >
                    {specialtyDetails.title}
                  </a>
                )}
              </Stack>
            </Stack>
          )}
        </Stack>

        {hasJobs ? (
          <Carousel key={activeFilter} controls={computedItems.length > visibleCount} indicators={false}>
            {chunk(computedItems, visibleCount).map((pageOfJobs, k) => (
              <Carousel.Item key={k}>
                <Row>
                  {pageOfJobs.map((job) => (
                    <Col key={job.id} xs={12} md={12 / visibleCount} className="mb-4">
                      <JobCard className="bg-white h-100" {...job} />
                    </Col>
                  ))}
                </Row>
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          activeFilter !== "all" && (
            <div className="text-center my-5">
              <p className="h5">No jobs available in this specialty.</p>
              <p>Please check back later or view all our available positions.</p>
            </div>
          )
        )}

        <div className={classes.jobs__footer}>
          {button &&
            button.map((btn, k) => (
              <CTA
                key={k}
                label={btn.label}
                href={btn.href}
                className={clsx("mt-4")}
                variant={btn.variant}
                target={btn.open_in_new_tab ? "_blank" : undefined}
              />
            ))}
        </div>
      </Container>
    </div>
  );
};

export default LatestJobs;
